import type {ReactNode} from 'react'
import React from 'react'
import {Navigate, Route} from 'react-router-dom'

import {useFlags} from '@product-web/flags'
import {roleSets} from '@product-web/shell/user'

const ReviewPage = React.lazy(async () => import('./screens/review'))

export const routes = (
    <Route handle={{auth: true, allowedRoles: roleSets.companyAndReviewer}}>
        <Route
            index
            element={
                <ReviewPageGate>
                    <ReviewPage />
                </ReviewPageGate>
            }
        />
        <Route
            path="review/*"
            element={
                <ReviewPageGate>
                    <ReviewPage />
                </ReviewPageGate>
            }
        />
    </Route>
)

/**
 * Only allows navigation to the review page
 * if the feature flag is enabled for now.
 */
function ReviewPageGate({children}: {children: ReactNode}): JSX.Element {
    const {reviewPage: isReviewPageEnabled} = useFlags()
    return isReviewPageEnabled ? <>{children}</> : <Navigate to="/" replace />
}
